/**
 * Reports API Service
 * 
 * Handles all API calls related to reports and business insights
 */
import { apiService as api } from './api.service';

// API endpoints
const ENDPOINTS = {

  
  // Business Insights
  BUSINESS_INSIGHTS_REPORTS: '/business-insights/reports',
  BUSINESS_INSIGHTS_REPORT_BY_ID: (reportId) => `/business-insights/reports/${reportId}`,
  
  // Conversation
  BUSINESS_INSIGHTS_CONVERSATION: '/business-insights/conversation',
  BUSINESS_INSIGHTS_CONVERSATION_HISTORY: (conversationId) => 
    `/business-insights/conversation/${conversationId}/history`
};

/**
 * Reports API functions
 */
export const reportsService = {
  // Reports
  // Business Insights
  getBusinessInsightsReports: (params) => api.get(ENDPOINTS.BUSINESS_INSIGHTS_REPORTS, { params }),
  getBusinessInsightsReportById: (reportId) => api.get(ENDPOINTS.BUSINESS_INSIGHTS_REPORT_BY_ID(reportId)),
  
  // Conversation
  createOrContinueConversation: (data) => api.post(ENDPOINTS.BUSINESS_INSIGHTS_CONVERSATION, data),
  getConversationHistory: (conversationId) => api.get(ENDPOINTS.BUSINESS_INSIGHTS_CONVERSATION_HISTORY(conversationId))
}; 